// ページ内ジャンプボタン: <button data-mp-jump="#payment-methods">
// 対象へスムーズスクロールし、フォーカスを移す（旧 main.js の setupPaymentJumps を data 属性化）。

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export function setupJumps() {
  document.querySelectorAll('[data-mp-jump]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.querySelector(button.dataset.mpJump);
      if (!target) return;
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      target.focus({ preventScroll: true });
    });
  });
}
